import { createAction, props } from '@ngrx/store';
import { Automation } from '../models';

export const loadAutomationDetails = createAction(
  '[Automation Details] Load Automation Details',
  props<{ automationId: string }>()
);

export const loadAutomationDetailsSuccess = createAction(
  '[Automation Details] Load Automation Details Success',
  props<{ automation: Automation }>()
);

export const loadAutomationDetailsFailure = createAction(
  '[Automation Details] Load Automation Details Failure',
  props<{ error: string }>()
);

export const updateAutomationDetails = createAction(
  '[Automation Details] Update Automation Details',
  props<{ automationId: string; data: Partial<Automation> }>()
);

export const updateAutomationDetailsSuccess = createAction(
  '[Automation Details] Update Automation Details Success',
  props<{ automation: Automation }>()
);

export const updateAutomationDetailsFailure = createAction(
  '[Automation Details] Update Automation Details Failure',
  props<{ error: string }>()
);

export const addDocumentToAutomation = createAction(
  '[Automation Details] Add Document To Automation',
  props<{ automationId: string; document: any }>()
);

export const updateDocumentInAutomation = createAction(
  '[Automation Details] Update Document In Automation',
  props<{ automationId: string; documentId: string; data: any }>()
);

export const resetAutomationDetails = createAction('[Automation Details] Reset Automation Details');
